/*
 * Định tuyến Simba. Đường dẫn giữ nguyên như bản cũ để link đã chia sẻ vẫn đúng.
 * Trang lớp học: /classes/:slug/:section/:subId? — :subId là product, concept,
 * reflection… tuỳ mục.
 */
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom"
import { PublicLayout } from "./PublicLayout"
import { ClassLayout } from "./ClassLayout"
import { RouteError } from "./RouteError"
import { BehaviorTracker, ReferralTracker } from "./trackers"
import HomePage from "@/routes/home"
import CoursePreviewPage from "@/routes/course-preview"
import JoinPage from "@/routes/join"
import MyCoursesPage from "@/routes/my-courses"
import SettingsPage from "@/routes/settings"
import FamilyPage from "@/routes/family"
import FeedbackPage from "@/routes/feedback"
import ReferralsPage from "@/routes/referrals"
import AuthReturnPage from "@/routes/auth-return"
import ClassStartPage from "@/routes/class/start"
import ClassOverviewPage from "@/routes/class/overview"
import ClassProductsPage from "@/routes/class/products"
import ClassConceptsPage from "@/routes/class/concepts"
import ClassSessionsPage from "@/routes/class/sessions"
import ClassClassmatesPage from "@/routes/class/classmates"
import ClassSubmissionsPage from "@/routes/class/submissions"
import ClassPortfolioPage from "@/routes/class/portfolio"
import ClassAlbumPage from "@/routes/class/album"
import ClassOnboardingPage from "@/routes/class/onboarding"
import ClassContributionsPage from "@/routes/class/contributions"
import ClassDiscoverPage from "@/routes/class/discover"
import ClassReflectionsPage from "@/routes/class/reflections"
import ClassRewardsPage from "@/routes/class/rewards"
import ClassCertificatePage from "@/routes/class/certificate"

function Root() {
  return (
    <>
      <BehaviorTracker />
      <ReferralTracker />
      <Outlet />
    </>
  )
}

export const router = createBrowserRouter([
  {
    element: <Root />,
    errorElement: <RouteError />,
    children: [
      {
        element: <PublicLayout />,
        children: [
          { index: true, element: <HomePage /> },
          { path: "courses/:slug", element: <CoursePreviewPage /> },
          { path: "join/:token", element: <JoinPage /> },
          { path: "my-courses", element: <MyCoursesPage /> },
          { path: "settings", element: <SettingsPage /> },
          { path: "family", element: <FamilyPage /> },
          { path: "feedback", element: <FeedbackPage /> },
          { path: "referrals", element: <ReferralsPage /> },
          { path: "auth/login", element: <AuthReturnPage /> },
          { path: "*", element: <Navigate to="/" replace /> },
        ],
      },
      {
        path: "classes/:slug",
        element: <ClassLayout />,
        children: [
          { index: true, element: <Navigate to="start" replace /> },
          { path: "classroom", element: <Navigate to="../sessions" replace /> },
      { path: "start/:subId?", element: <ClassStartPage /> },
      { path: "overview/:subId?", element: <ClassOverviewPage /> },
      { path: "products/:subId?", element: <ClassProductsPage /> },
      { path: "concepts/:subId?", element: <ClassConceptsPage /> },
      { path: "sessions/:subId?", element: <ClassSessionsPage /> },
      { path: "classmates/:subId?", element: <ClassClassmatesPage /> },
      { path: "submissions/:subId?", element: <ClassSubmissionsPage /> },
      { path: "portfolio/:subId?", element: <ClassPortfolioPage /> },
      { path: "album/:subId?", element: <ClassAlbumPage /> },
      { path: "onboarding/:subId?", element: <ClassOnboardingPage /> },
      { path: "contributions/:subId?", element: <ClassContributionsPage /> },
      { path: "discover/:subId?", element: <ClassDiscoverPage /> },
      { path: "reflections/:subId?", element: <ClassReflectionsPage /> },
      { path: "rewards/:subId?", element: <ClassRewardsPage /> },
      { path: "certificate/:subId?", element: <ClassCertificatePage /> },
        ],
      },
    ],
  },
])
